import { Predicate } from "effect";

const getFormFromSubmitEvent = (e: SubmitEvent): HTMLFormElement | null => {
  const t = e.target;
  return t instanceof HTMLFormElement ? t : null;
};

export const isAddToCartAction: Predicate.Predicate<SubmitEvent> = (e) => {
  const form = getFormFromSubmitEvent(e);
  if (!form) return false;

  const atcRoute = window.BrytDesigns.routes.cart_add_url.replace(".js", "");

  // If you want to be robust to absolute URLs, use URL parsing.
  // Keeping it simple per your request:
  return form.action === atcRoute || form.getAttribute("action") === atcRoute;
};

export const isSubmitEvent: Predicate.Predicate<SubmitEvent> = (e) =>
  e instanceof SubmitEvent;

export const isAddToCartSubmitEvent: Predicate.Predicate<SubmitEvent> =
  Predicate.and(isSubmitEvent, isAddToCartAction);
